import { SiteResolver } from '@sitecore-content-sdk/nextjs/site';
import { mergedSites } from './build-sites';

/*
  The site resolver stores site information and is used across the app
  whenever site lookup is required (e.g. by host in API routes).
  Sites are sourced from .sitecore/sites.json (generated by CSDK) merged with
  the custom domain mappings from the domain query (scripts/domains/domains.json)
  so that custom country domains resolve to the correct site by host.
*/

export const siteResolver = new SiteResolver(mergedSites);
